import React from 'react'
import ConstructionServices from '../../components/User/Home/ConstructionServices'
import WhoWeAre from '../../components/User/Home/WhoWeAre'
import RecentWorks from '../../components/User/Home/RecentWorks'
import WhyChooseUs from '../../components/User/Home/WhyChooseUs'
import HowWeWork from '../../components/User/Home/HowWeWork'
import ClientReviews from '../../components/User/Home/ClientReviews'
import GetInvolved from '../../components/User/Home/GetInvolved'
import FAQ from '../../components/User/Home/FAQ'
import Hero from '../../components/User/Home/Hero'
import CompanyOverview from '../../components/User/About/Companyoverview'

const Home = () => {
  return (
    <div>
      <Hero/>
      <CompanyOverview/>
      <WhoWeAre/>
      <ConstructionServices/>
      {/* <RecentWorks/> */}
      <WhyChooseUs/>
      <HowWeWork/>
      <ClientReviews/>
      <GetInvolved/>
      <FAQ/>
    </div>
  )
}

export default Home